import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSustainabilityinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "#000",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 32,
				cy: 18,
				r: 6
			}),
			/* @__PURE__ */ _jsx("path", { d: "M32 9.99871878v-4M32 29.997438v-4M40.0027192 18.000562h4M20.0037192 18.0008428h4M38.0727194 11.92841212l2.82842713-2.82842713M23.10320434 26.89841212l2.82842712-2.82842713M38.07245636 24.07358788l2.82842712 2.82842713M23.10267853 9.10529499l2.82842716 2.82842715M27 53c0-12.1502645 9.8497355-22 22-22 1.4664003 0 2.8992915.143469 4.2854029.4171362C53.751731 33.1999646 54 35.0709891 54 37c0 12.1502645-9.8497355 22-22 22-1.4664003 0-2.8992915-.143469-4.2854029-.4171362C27.248269 56.8000354 27 54.9290109 27 53z" }),
			/* @__PURE__ */ _jsx("path", { d: "M27 53c0 1.9290109.248269 3.8000354.7145971 5.5828638.6930557.1368336 1.3978063.2411176 2.1125931.3111933C18.6968505 57.8028705 10 48.4170644 10 37c0-1.9290109.248269-3.8000354.7145971-5.5828638C12.1007085 31.143469 13.5335997 31 15 31c6.8479352 0 12.9651091 3.128761 17 8.0347612C28.8757998 42.8334579 27 47.6976707 27 53zm5 6c-.7332001 0-1.458023-.0358673-2.1728098-.1059429L32 59zm-4-1l25-26M36 50V35M25 46v-8m-9-1v-6m30 8v-7M33 53h6.5M15 51h12.5M11 43h11m18.487093 2H52m-24.5 3.5L11 32" })
		]
	})
});
export default SvgSustainabilityinline;
